import React from 'react';

export const DataRefreshContext = React.createContext<{ refreshCounter: number, refresh: (againWithDelay?: boolean) => void }>({ refreshCounter: 0, refresh: () => { } });

export const DataAutoRefreshContext = React.createContext<{ interval: number, disabled: boolean, enable: () => void, disable: () => void, setInterval: (i: number) => void }>({ interval: 60000, disabled: false, enable: () => { }, disable: () => { }, setInterval: () => { } });